// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientsInFacility_container__3AhVC","text":"PatientsInFacility_text__Pmx8p","icon":"PatientsInFacility_icon__3bwl0"};